var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container__cloud"},[_c('p',{staticClass:"title"},[_vm._v("가비아를 이용해주셔서 감사합니다.")]),_c('div',{staticClass:"container__content"},[_c('cloud-step-03-template',{attrs:{"auto-settle":_vm.autoSettle,"pay-method":_vm.payMethod}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }